import { useLoaderData, useLocation } from '@remix-run/react';
import NotFound from '@modules/error/component/not-found/NotFound';
import ErrorPageWrapper from '@modules/error/component/error-page-wrapper/ErrorPageWrapper';
import { ServerErrorPage } from '@modules/error';
import type { loader } from '~/routes/_app.$';

const NotFoundPage = () => {
    const { statsNumbers } = useLoaderData<typeof loader>();
    const location = useLocation();
    if (!statsNumbers) {
        return (
            <ServerErrorPage
                error={
                    new Error(
                        `Cannot load 'NotFoundPage' data at ${location.pathname}. This generally occurs when using router links instead of browser`
                    )
                }
            />
        );
    }
    return (
        <ErrorPageWrapper>
            <NotFound />
        </ErrorPageWrapper>
    );
};

export default NotFoundPage;
